export default __webpack_public_path__ + "static/media/guia-1-5.a526bf19.svg";